import Alert from "@mui/material/Alert";
import Snackbar from "@mui/material/Snackbar";
import { useDispatch, useSelector } from "react-redux";
import {
  removeNotification,
  selectNotificationById,
  selectNotificationIds,
} from "../redux/notifications";

const Notification = (props) => {
  const dispatch = useDispatch();
  const notification = useSelector((state) =>
    selectNotificationById(state, props.id),
  );
  return (
    <Snackbar
      autoHideDuration={5000}
      open={true}
      onClose={() => dispatch(removeNotification(notification.id))}
    >
      <Alert severity={notification.severity} sx={{ width: "100%" }}>
        {notification.message}
      </Alert>
    </Snackbar>
  );
};

const Notifications = (props) => {
  const notificationIds = useSelector(selectNotificationIds);
  const headId = notificationIds[0];
  return headId && <Notification key={headId} id={headId} />;
};

export default Notifications;
